<template>
	<div>
			<el-row :gutter="40">
			  <el-col  style=" cursor: pointer;" v-for="item in gridData" :key="item.id" :xs="24" :sm="12" :md="8" :lg="6" >
			    <div @click="toPath(item)" :title="item.remark">
				<el-card shadow="hover" style="border: 0px" >
			      <img :src="item.icon" class="grid-logo" />
			      <div class="grid-info"  >
			        <h3 class="grid-title">{{ item.name }}</h3>
			        <!-- <p class="grid-description">{{ item.remark }}</p> -->
			      </div>
			    </el-card>
			    </div>
			  </el-col>
				
			</el-row>
	<!-- 		   <img id="a3" src="https://picsum.photos/200/200/?image=3" draggable="true" @dragstart="drag">
			   <br>
			   <div @dragover="allowDrag" @drop="drop" style="width: 200px;height: 200px;"> 123</div> -->
		</div>
</template>

<script>
	export default{
		props:{
			menuId:String,
			home:Object
		},
		data(){
			return{
				gridData: [
	

			
				  ],
			}
		},
		methods:{
			toPath(item){
				console.log("--")
				this.$api.updateClickCount({id:item.id}).then(res=>{
					console.log('succ')
				})
				
				if(item.url!=undefined&&item.type==1){
					if(item.isCross==1){
					this.$router.push(item.url)
					}else{
						    this.$notify.info({
						          title: '消息提示',
						          message: '该功能还未完成，敬请期待！'
						        });
					}
				}
				
			},
			loadAboutWebsite(){
				this.home.contentLoading=true
				this.$api.getWebsites({menuId:this.menuId}).then(res=>{
					this.gridData=res.data.data
					this.home.contentLoading=false
				})
			}
	
		},
		mounted() {
			
			this.loadAboutWebsite()
		}
	}
</script>

<style>
</style>